import { IONICWrapper } from "../../utils/common";
import {
  APP_DOWNLOAD_ALERT,
  PLATFORM_INCOMPATIBLE_MESSAGE,
  FPC_DYNAMIC_LINK
} from "../../utils/constants";
import React, { useState } from "react";
import { Alert } from "../Alert/Alert";

const AppDownload = () => {
  const [showAppDownload, setAppDownload] = useState(true);
  const platformIncompatibleMessage =
    IONICWrapper.details.keys.configuration?.platformIncompatibleMessage ||
    PLATFORM_INCOMPATIBLE_MESSAGE;
  const fpcDynamicLink =
    IONICWrapper.details.keys.configuration?.fpcDynamicLink || FPC_DYNAMIC_LINK;

  const downloadApp = () => {
    (typeof window === "object") && (window.location.href = fpcDynamicLink);
  };

  return (
    <Alert
      isOpen={showAppDownload}
      message={platformIncompatibleMessage}
      backdropDismiss={false}
      cssClass="update-alert"
      mode={"md"}
      buttons={[
        {
          text: APP_DOWNLOAD_ALERT.INSTALL_NOW,
          role: "Ok",
          handler: () => {
            downloadApp();
          },
        },
        {
          text: APP_DOWNLOAD_ALERT.CANCEL,
          role: "Cancel",
          handler: () => {
            setAppDownload(false);
          },
        },
      ]}
    />
  );
};

export default AppDownload;
